module.exports = __webpack_public_path__ + "img/1g.3def1b09.png";